import http from '@/services/api';

const RESOURCE_NAME = 'api/help';

export default {
  getAllHelpDocuments() {
    return http.get(`${RESOURCE_NAME}/documentation/all`);
  },

  getHelpDocumentById(documentId) {
    return http.get(`${RESOURCE_NAME}/documentation/${documentId}`);
  },

  getReleaseNotes(releaseVersion) {
    return http.get(`${RESOURCE_NAME}/releaseNotes/${releaseVersion}`);
  }
};
